import { Component, EventEmitter, Input, Output } from '@angular/core';

/**
 * Carte de sélection générique : image centrée (background-image) + libellé.
 * Gère en interne l'état de chargement de l'image.
 *
 * @example
 * <ng-casto-selection-card
 *   [imgSrc]="apiUrl + item.icon"
 *   [label]="item.name"
 *   [active]="isSelected(item.id)"
 *   (cardSelect)="select(item)">
 * </ng-casto-selection-card>
 */
@Component({
  selector: 'ng-casto-selection-card',
  templateUrl: './selection-card.component.html',
  styleUrls: ['./selection-card.component.scss'],
})
export class SelectionCardComponent {
  /** URL complète de l'image à afficher */
  @Input() imgSrc: string;

  /** Libellé affiché sous l'image */
  @Input() label: string;

  /** La carte est-elle sélectionnée ? */
  @Input() active: boolean = false;

  /** La carte est-elle désactivée ? */
  @Input() disabled: boolean = false;

  /** Émis au clic (ignoré si disabled) */
  @Output() cardSelect = new EventEmitter<void>();

  imageLoaded = false;

  onImageLoad(): void {
    this.imageLoaded = true;
  }

  onClick(): void {
    if (!this.disabled) {
      this.cardSelect.emit();
    }
  }
}
